import React from 'react';
import { Switch } from 'react-router-dom';
import { LazyRoute } from 'modules';
import { isPro } from 'utils';
import { getFeatureFlags } from 'services';
import { translateRoute } from './translateRoute';

const FEATURE_FLAG_LOYALTY = 'ff.loyalty.homepage';

/**
 * exported for testing purposes
 */
export const Checkout = () => import('@checkout');
export const Afterbuy = () => import('@afterbuy');
export const Relevance = () => import('@relevance');
export const Loyalty = () => import('@loyalty');

const Router = () => {
  const featureFlags = getFeatureFlags();
  return (
    <>
      <Switch>
        {translateRoute('/delivery') && (
          <LazyRoute path={translateRoute('/delivery')} module={Checkout} />
        )}
        {translateRoute('/secure-payment') && (
          <LazyRoute
            path={translateRoute('/secure-payment')}
            module={Checkout}
          />
        )}
        {translateRoute('/orders/track-line/:id?') && (
          <LazyRoute
            exact
            path={translateRoute('/orders/track-line/:id?')}
            module={Afterbuy}
          />
        )}
        {translateRoute('/track-my-parcel/track-line/:id') && (
          <LazyRoute
            exact
            path={translateRoute('/track-my-parcel/track-line/:id')}
            module={Afterbuy}
          />
        )}
      </Switch>
      {isPro() && featureFlags[FEATURE_FLAG_LOYALTY] === 'ON' && (
        <LazyRoute module={Loyalty} />
      )}
      <LazyRoute module={Relevance} />
    </>
  );
};

export default Router;
